/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 */

module.exports = require('./db.json')



//////////////////
// WEBPACK FOOTER
// ./~/mime-db/index.js
// module id = 3147
// module chunks = 0